module.exports = __webpack_public_path__ + "static/wesfarmers-video-poster-8afdb660ca560e2455b039fcfb682982.png";